module.exports = __webpack_public_path__ + "static/gridmarketing__header-gradient@2x-ed2ed1dcd52d461fb59055e2af183f86.png";